import './tooltip-dialog-fixed.component.scss';

import { useState, memo } from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';

const TooltipDialogFixed = props => {
  const {
    title,
    showSec,
    hideSec,
    placement,
    className,
    hideIcon,
    tooltipsTitle,
  } = props;

  const currentShowSec = showSec || 100;
  const currentHideSec = hideSec || 100;
  const isHideIcon = !!hideIcon ? true : false;

  const [isHover, setIsHover] = useState(false);
  const handleMouseEnter = () => {
    setIsHover(true);
  };

  const handleMouseLeave = () => {
    setIsHover(false);
  };

  return (
    <OverlayTrigger
      placement={placement}
      delay={{ show: currentShowSec, hide: currentHideSec }}
      show={isHover}
      overlay={
        <Popover
          bsPrefix="tooltips-popover popover"
          body
          spacing={3}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          {<span dangerouslySetInnerHTML={{ __html: title }}></span>}
        </Popover>
      }
    >
      <a
        href="#/"
        className={`${!hideIcon && 'tooltips-icon'} ${className || ''}`}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {isHideIcon && tooltipsTitle}
      </a>
    </OverlayTrigger>
  );
};

export default memo(TooltipDialogFixed);

// placemanet : 'auto-start' | 'auto' | 'auto-end' | 'top-start' | 'top' | 'top-end' | 'right-start' | 'right' | 'right-end' | 'bottom-end' | 'bottom' | 'bottom-start' | 'left-end' | 'left' | 'left-start'
